<template>
  <div class="">
    <div class="actList-wrap-Em4pi">
      <div
        class="actList-item-Sk81R"
        @click="openUrl(item)"
        v-for="(item, index) in activitiesList"
      >
        <img :src="item.image" alt="" sizes="" srcset="" />
        <p class="actList-item-name-qraJj">{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { activities } from '@/apis/modules/event.js';
export default {
  data() {
    return {
      activitiesList: []
    };
  },
  created() {
    this.getActivities();
  },
  methods: {
    openUrl(e) {
      if (e.jump_url == 'dailySignIn') {
        this.$store.commit('publicFun', ['CancelIsSigned_days', true]);
        return false;
      }
      if (e.type == 'direct') {
        if (e.jump_url && e.jump_url != '#') {
          if (/^http/.test(e.jump_url)) {
            window.open(e.jump_url, '_blank');
            return false;
          }
          // this.$router.replace('/home')
          this.$router.replace({ name: e.jump_url });
          // this.$router.push({name:e.jump_url})
        }
        // 跳转类型：direct直接跳URL，rich跳页面展示富文本（标题和内容）
      } else {
        this.$router.replace({
          name: 'details',
          query: {
            title: e.title,
            content: e.content
          }
        });
        // this.$router.push()
      }
    },
    getActivities() {
      activities({}).then(({ code, data = {}, msg }) => {
        this.activitiesList = data;
      });
    }
  }
};
</script>
<style scoped>
.actList-wrap-Em4pi {
  display: flex;
  overflow: auto;
  width: 100%;
  overflow: scroll;
  margin-bottom: 1.5rem;
}
.actList-item-Sk81R {
  width: 1.88rem;
  min-height: 0.9rem;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-right: 0.2rem;
  cursor: pointer;
}

.actList-item-name-qraJj {
  font-size: 0.2rem;
  margin-top: 0.04rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  width: 100%;
  color: var(--theme-btm-def-color);
}
</style>
